module.exports = "/img/comment.svg?7ad5b4990d51378731989242a1df437f";